import { createAction } from '@lingoda/core';
import type { DialogId } from '../models';

export default createAction<DialogId>('dialog/REMOVE_DIALOG');
